export default __webpack_public_path__ + "static/media/a893282f41277d460af9d426012f0b271600887656866.1fbefda2.webp";